
    export default 
    {
    "market": {
        "placeholder": "Ingresa las palabras clave para buscar",
        "import_to_dsers": "Importar a Dsers",
        "import_tip_title": "Por favor, selecciona las tiendas para importar productos"
    }
}